import React from "react";
import styles from "./ProgramOverview.module.scss";
import { LordIcon } from "../lord-icon/lord-icon";
import { IconClock, IconLesson, IconRewards, IconTier } from "@src/constants";
import { SllProgram } from "@src/api/graphql-codegen";
import { getMediaAbsolutePath } from "@src/services/File";
import IconStar from '@assets/icons/star_filled.svg?react'
import IconArrowUp from 'src/assets/icons/dropdown.svg?react';
import Button from "../button/Button";
import { useHistory } from "react-router-dom";
import { generateSlug } from "@src/utils/helpers";
import ImageStudentVoiceSeries from '@assets/img/studentvoiceseries.jpg';

type Props = {
  program: SllProgram;
  isSuperAdmin?: boolean | false;
  isAusStudentVoiceSeries?: boolean | false;
};

function ProgramOverview(props: Props) {
  const { program, isSuperAdmin, isAusStudentVoiceSeries } = props;
  const history = useHistory();

  const handleOpenProgram = () => {
    if (program) {
      history.push(`/program/${generateSlug(program.name)}?pid=${program.id}`, { program: program });
      return;
    }
  }

  const text = program?.description;
  const boldText = program ? text?.replace(program.name, `<strong>${program.name}</strong>`) : "";

  return (
    <div className={styles.card}>
      <div className={styles.overviewDetail}>
        <div className={styles.gradeGrayView}>
          <div className={styles.overviewSection}>
            {!isSuperAdmin && <LordIcon size={30} src={program.iconUrl || 'https://cdn.lordicon.com/pmfpsjek.json'} />}
            <h1>{isSuperAdmin ? 'Overview' : program.name}</h1>
            {program?.labels !== 'None' && <div className={styles.featuredLabel}><IconStar /> {program.labels}</div>}
          </div>
        </div>
        <div className={styles.programCardView}>
          <div>
          {!!program.bannerImage && (<div style={{cursor: 'pointer'}} onClick={handleOpenProgram}>
            <img
              src={getMediaAbsolutePath(program.bannerImage) || ""}
              alt="program"
              className={styles.programImage}
            />
          </div>)}
          {isAusStudentVoiceSeries && (<div style={{cursor: 'pointer'}} onClick={handleOpenProgram}>
            <img
              src={ImageStudentVoiceSeries}
              alt="program"
              className={styles.programImage}
            />
          </div>)}
          </div>
          <div className={styles.itemRightView}>
            <div className={styles.itemDetails} dangerouslySetInnerHTML={{ __html: boldText ?? "" }} />
            <div className={styles.rightBottomView}>
              <div className={styles.gradeItem}>
                <LordIcon
                  src={IconRewards}
                  colors={{ primary: "#274649", secondary: "#274649" }}
                  size={32}
                />
                <span>{program.grade}</span>
              </div>
              <div className={styles.otherItem}>
                <LordIcon
                  src={IconClock}
                  colors={{ primary: "#274649", secondary: "#274649" }}
                  size={32}
                />
                <div className={styles.itemLessonView}>
                  <span>{program.avgDuration}&nbsp;min</span>
                  <span className={styles.perLesson}>{"per Lesson"}</span>
                </div>
              </div>
              <div className={styles.otherItem}>
                <LordIcon
                  src={IconLesson}
                  colors={{ primary: "#274649", secondary: "#274649" }}
                  size={32}
                />
                <span
                  style={{ marginLeft: 3 }}
                >{`${program.numberOfLessons} Lessons`}</span>
              </div>
              <div className={styles.otherItem}>
                <LordIcon
                  src={IconTier}
                  colors={{ primary: "#274649", secondary: "#274649" }}
                  size={32}
                />
                <span>{program.tier}</span>
              </div>
            </div>
          </div>
        </div>
        {!isSuperAdmin && <div>
          <div className={styles.hoverTitleView}>
            <div className={styles.hoverTitleSubView}>
              <Button size='small' className={styles.extendViewButton} label={"View Lessons"}
                rightIcon={<IconArrowUp className={styles.arrowRightIcon} width={13} />} onClick={handleOpenProgram}/>
            </div>
          </div>
        </div>}
      </div>
    </div>
  );
}

export default ProgramOverview;
